import {createSelector} from 'reselect';
import {getContactNumberRules} from '../selectors';

export default createSelector(
  [getContactNumberRules],
  fieldRules => fieldRules?.regexValidation,
);
